import * as React from "react"
import { storyblokEditable, renderRichText, StoryblokComponent } from "gatsby-source-storyblok"
import { Lang, LangEnum, Trans } from "../utils/lang"
import * as styles from "./accommodationItem.module.css"
import HotelCarouselSection from "./hotelCarouselSection"
import { TourTag } from "./tourTags"

const AccommodationItem = ({ blok }) => {

  const lang = Lang()
  const vacationLink = lang === LangEnum.JA ? '/ja/tours' : '/luxury-vacation'
  
  return (
    <div {...storyblokEditable(blok)}>
      { blok.noOverlap &&
      <section className="hero-image-section">
        <div className="w-full text-white pt-10 pb-10 bg-black" style={{backgroundColor: blok.bgColor?.color, color: blok.textColor?.color}}>
          <nav className="text-center text-sm pb-3 px-4">
          { lang == LangEnum.EN &&
          <>
            <a href={`${lang}/`} className="hover:text-gray-300 border-b-2">Home</a>
            <img src="/icons/breadcrumb-arrow-right.svg" alt="breadcrumb" className="inline-block w-4 h-4 mx-4" />
            <a href={`${vacationLink}`} className="hover:text-gray-300 border-b-2">{Trans('luxuryVacation')}</a>
            <div className="w-full">
              <img src="/icons/breadcrumb-arrow-down.svg" alt="breadcrumb" className="ml-24 inline-block w-4 h-4 my-4" />
            </div>
          </>
          }
          </nav>
          
          <div className="text-center px-4">
            <div className={`${styles.region} text-2xl mb-3`}>{blok.region}</div>
            <div className="text-4xl font-serif font-bold">{blok.hotelName}</div>
          </div>
        </div>

        <div className="flex flex-wrap items-center justify-center bg-black" style={{backgroundColor: blok.bgColor?.color}}>
          <img className="w-full md:w-1/2 object-contain" loading="lazy" src={`${blok.leftBannerImage?.filename}/m/`} alt={blok.leftBannerImage?.alt} />
          {blok.rightBannerImage?.filename && 
          <img className="w-full md:w-1/2 object-contain" loading="lazy" src={`${blok.rightBannerImage?.filename}/m/`} alt={blok.rightBannerImage?.alt} /> 
          }
        </div>

        <div className="w-full bottom-0 bg-black text-white text-center" style={{backgroundColor: blok.bgColor?.color, color: blok.textColor?.color}}>
          {blok.hotelBannerImage?.filename && <img className="h-[70px] md:w-full object-cover" src={`${blok.hotelBannerImage?.filename}/m/`} alt={blok.hotelBannerImage?.alt} />}
          <div className="md:w-[890px] px-5 md:px-20 py-10 mx-auto" dangerouslySetInnerHTML={{__html: renderRichText(blok.overview)}} />
        </div>        
      </section>
      }

      { !blok.noOverlap &&
      <section className="hero-image-section relative">
        <div className="grid grid-cols-2 mb-28">
          <img className="w-full h-[600px] object-cover" loading="lazy" src={`${blok.leftBannerImage?.filename}/m/`} alt={blok.leftBannerImage?.alt} />
          <img className="w-full h-[600px] object-cover" loading="lazy" src={`${blok.rightBannerImage?.filename}/m/`} alt={blok.rightBannerImage?.alt} />
        </div>
        <div className="absolute top-0 right-0 left-0 m-auto w-full md:w-[790px] h-[710px] z-[1] bg-black opacity-60"></div>
        <div className="absolute top-0 right-0 left-0 m-auto w-full md:w-[790px] h-[710px] z-[2] text-white">
          <nav className="text-center text-sm mt-20 md:mt-[160px] mb-5 px-4">
          { lang == LangEnum.EN &&
          <>
            <a href={`${lang}/`} className="hover:text-gray-300 border-b-2">Home</a>
            <img src="/icons/breadcrumb-arrow-right.svg" alt="breadcrumb" className="inline-block w-4 h-4 mx-4" />
            <a href={`${vacationLink}`} className="hover:text-gray-300 border-b-2">{Trans('luxuryVacation')}</a>
            <div className="w-full">
              <img src="/icons/breadcrumb-arrow-down.svg" alt="breadcrumb" className="ml-24 inline-block w-4 h-4 my-4" />
            </div>
          </>
          }
          </nav>
          <div className="text-center px-4">
            <div className={`${styles.region} text-2xl mb-6`}>{blok.region}</div>
            <div className="text-4xl font-serif font-bold">{blok.hotelName}</div>
          </div>
          <div className="absolute w-full bottom-0 bg-black text-white text-center">
            {blok.hotelBannerImage?.filename && <img className="h-[70px] md:w-full object-cover" src={`${blok.hotelBannerImage?.filename}/m/`} alt={blok.hotelBannerImage?.alt} />}
            <div className="px-5 md:px-20 py-10" dangerouslySetInnerHTML={{__html: renderRichText(blok.overview)}} />
          </div>
        </div>
      </section>
      }

      {blok.label && 
      <div className="container mx-auto flex justify-center p-5">
        {blok.label?.value?.map((tag, index) => ( <TourTag key={index} tag={tag} /> ))}
      </div>
      }

      <section className="my-32">
        {blok.carouselItem?.map((item) => (<HotelCarouselSection blok={item} key={item._uid}/>))}
      </section>

      <section className="flex flex-wrap justify-center gap-9 my-28">
        <div className="max-w-[570px] p-4">
          <h4 className="text-2xl font-bold my-8">{Trans('details')}</h4>
          <table className="table-auto">
            <tbody className="border-t-2 border-black text-sm">
              { blok.address && 
                <tr className="border-b border-black odd:bg-gray-50">
                  <td className="border-r border-black py-2 px-4 align-top">Address</td>
                  <td className="py-2 px-4 align-top">{blok.address}</td>
                </tr> 
              }
              {blok.phone &&
                <tr className="border-b border-black odd:bg-gray-50">
                  <td className="border-r border-black py-2 px-4 align-top">Phone</td>
                  <td className="py-2 px-4 align-top">{blok.phone}</td>
                </tr>
              }
              {blok.noOfRooms &&
                <tr className="border-b border-black odd:bg-gray-50">
                  <td className="border-r border-black py-2 px-4 align-top">No. of Rooms</td>
                  <td className="py-2 px-4 align-top">{blok.noOfRooms}</td>
                </tr>
              }
              {blok.checkInCheckOut &&
                <tr className="border-b border-black odd:bg-gray-50">
                  <td className="border-r border-black py-2 px-4 align-top">Check-in / Check-out</td>
                  <td className="py-2 px-4 align-top">{blok.checkInCheckOut}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
        <div className="max-w-[375px] sm:max-w-[600px] overflow-hidden" dangerouslySetInnerHTML={{__html: blok.mapEmbeddedCode}} />
      </section>
          
      {blok.body?.map((nestedBlok) => (
        <StoryblokComponent blok={nestedBlok} key={nestedBlok._uid} />
      ))}

    </div>
  )
};

export default AccommodationItem;
